<template>
  <div class="portMain">
    <div class="liteTitle">充电桩编号：{{ deviceNo }}</div>
    <div class="list-box">
      <div class="list-item" @click="editPort(item, item.state)" v-for="(item, index) in portList"
           :key="`list-item_${index}`">
        <div class="header-box">
          <div class="name">{{ item.name }}</div>
          <div class="state-box">
            <div class="state-item state-item_1" v-if="Number(item.state) === 1">
              {{ portStatus[item.state].portStatus }}
            </div>
            <div class="state-item state-item_2" v-else-if="Number(item.state) === 2">
              {{ portStatus[item.state].portStatus }}
            </div>
            <div class="state-item state-item_3" v-else-if="Number(item.state) === 3">
              {{ portStatus[item.state].portStatus }}
            </div>
            <div class="state-item state-item_4" v-else-if="Number(item.state) === 4">
              {{ portStatus[item.state].portStatus }}
            </div>
            <div class="state-item state-item_5" v-else-if="Number(item.state) === 5">
              {{ portStatus[item.state].portStatus }}
            </div>
            <div class="state-item state-item_0" v-else>
              {{ portStatus[item.state].portStatus }}
            </div>
          </div>
        </div>
        <div class="data-info">
          <div class="info">
            <div class="info-item">
              <span>总收益(元)：</span>{{ handleControlNumber(item.orderGold, 2) }}元
            </div>
            <div class="info-item">
              <span>已充电量(度)：</span>{{ handleControlNumber(item.realHour, 2) }}小时
            </div>
            <div class="info-item">
              <span>充电时长(小时)：</span>{{ handleControlNumber(item.totalPowerConsumption, 2) }}度
            </div>
          </div>

          <div class="swatch-btn" @click.stop>
            <el-switch
                v-model="item.state"
                active-color="#165DFF"
                inactive-color="#CFD0D2"
                active-value="2"
                @change="((e) => switchPort(item.id, e == 2 ? 2 : 1))"
                :inactive-value="item.state ==0 || item.state ==1 || item.state ==3 || item.state ==4 || item.state ==5 ? item.state : 1"
                >
            </el-switch>
          </div>
        </div>
      </div>
    </div>
    <nut-dialog
        title="编辑端口"
        :visible="editportshow"
        @ok-btn-click="editPort2"
        @cancel-btn-click="switchActionSheet"
    >
      <el-form
          :model="editport"
          ref="form"
          size="normal"
          label-position="left"
          label-width="80px"
          style="overflow: hidden;"
      >
        <el-form-item label="编辑名称">
          <el-input
              v-model="editport.name"
              placeholder="请输入端口名称"
              size="normal"
              clearable
              maxlength="12"
          ></el-input>
        </el-form-item>
        <el-form-item label="端口状态">
          <el-select
              v-model="stateName"
              placeholder="请选择端口状态"
              style="width: 100%;"
              @focus="SelectState()"
          >
          </el-select>
        </el-form-item>
      </el-form>
    </nut-dialog>
    <nut-picker
        :is-visible="showStatePicker"
        :list-data="stateOptions"
        @close="showStatePicker = false"
        @confirm="confirmState"
    ></nut-picker>
  </div>
</template>
<script>
// 引入字典
import {portStatus} from "@/dictionary/dictionary";
import {getPortList, switchPort, editPort} from "@/api/newApi";
import {Toast} from "vant";
import {digitUtil} from "@/utils/utils";

export default {
  data() {
    return {
      showStatePicker: false,
      deviceNo: "",
      value1: 0,
      pageNo: 0,
      pageNum: 10,
      portStatus: portStatus,
      portList: [],
      editportshow: false,
      stateOptions: [
        [
          {value: "离线", label: '0'},
          {value: "故障", label: '1'},
          {value: "空闲", label: '2'},
          {value: "充电", label: '3'},
          {value: "已插枪", label: '4'},
          {value: "占用", label: '5'},
        ],
      ],
      stateName: "",
      editport: {
        name: "",
        deviceid: "",
        state: "",
        id: "",
      },
    };
  },
  mounted() {
    this.deviceNo = this.$route.params.id;
    this.getList();
  },
  methods: {
    handleControlNumber: digitUtil,
    getList(param) {
      this.pageSize += 3;
      getPortList({
        pageNo: this.pageNo,
        pageSize: this.pageNum,
        id: this.deviceNo,
      }).then((res) => {
        console.log("res", res);
        if (res.data.pages == 1) {
          //   Toast("已加载全部数据");
          this.loaded_all = true;
        }
        this.portList = res.data.records;
      });
    },
    switchPort(id, type) {
      let params = {
        id: id,
        portStatus: type,
      };
      switchPort(params).then((res) => {
        if (res.message.code == 0) {
          this.getList();
          Toast("操作成功");
        } else {
          Toast(res.message.message);
        }
      });
    },
    editPort(obj, state) {
      if (state == 3) {
        Toast("此端口正在使用无法编辑");
        return;
      }
      this.editport.pileType = obj.pileType
      this.editport.name = obj.name;
      this.editport.state = obj.state;
      this.editport.id = obj.id;
      this.editport.deviceid = obj.deviceid;
      this.stateName = this.portStatus[obj.state].portStatus;
      this.editportshow = !this.editportshow;
    },
    editPort2() {
      if (this.editport.name == "") {
        Toast("请填写端口名");
        return;
      }
      if (this.editport.state == "") {
        Toast("请选择端口状态");
        return;
      }
      editPort({
        id: this.editport.id,
        deviceid: this.editport.deviceid,
        parkid: this.deviceNo,
        name: this.editport.name,
        state: this.editport.state,
        pileType: this.editport.pileType,
      }).then((res) => {
        if (res.message.status == 200) {
          Toast("编辑端口成功");
          this.editportshow = false;
          this.editport.name = "";
          this.editport.state = "";
          this.stateName = "";
          this.pageNo = 0;
          this.getList();
        }
      });
      this.editportshow = true;
    },
    SelectState() {
      this.showStatePicker = true;
    },
    confirmState(data) {
      this.stateName = data[0].value;
      this.editport.state = data[0].label;
      this.showStatePicker = false;
    },
    switchActionSheet() {
      this.editportshow = !this.editportshow;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.portMain {
  //padding: 0.2667rem 0.4rem 1.76rem;
  padding: 0 $divPadding;

  .liteTitle {
    margin: $divPadding 0;
    font-size: 0.3783rem;
    font-weight: bold;
    color: #3D3D3D;
  }

  .list-box {
    .list-item {
      background-color: white;
      padding: 0.3rem;
      margin-bottom: $divPadding;
      border-radius: $borderRadius;

      .header-box {
        display: flex;
        justify-content: space-between;
        padding-bottom: 0.2rem;
        border-bottom: 1px solid #ECECEC;

        .name {
          font-size: 0.3783rem;
          font-weight: bold;
          align-self: center;
        }

        .state-box {
          .state-item {
            padding: 0.1rem 0.2rem;
            font-size: 0.2702rem;
            border-radius: 0.0540rem;
          }

          .state-item_Y {
            background-color: #faf0db;
            color: #eba40a;
          }

          .state-item_N {
            background-color: #E8F3FF;
            color: #165DFF;
          }

          .state-item_L {
            background-color: #888888;
            color: #fff;
          }

          .state-item_E {
            background-color: #FAE5E5;
            color: #D15F5F;
          }

          /*离线*/
          .state-item_0 {
            color: #ccc;
          }

          /*故障*/
          .state-item_1 {
            color: #f3252a;
          }

          /*空闲*/
          .state-item_2 {
            color: #4eda68;
          }

          /*充电*/
          .state-item_3 {
            color: #6886de;
          }

          /*已插枪*/
          .state-item_4 {
            color: #F0B515;
          }

          /*占用中*/
          .state-item_5 {
            color: #ffad66;
          }


        }
      }

      .data-info {
        display: flex;

        .info {
          flex: 1;
          margin-top: 0.1rem;

          .info-item {
            margin-top: 0.2rem;
            font-size: 0.3243rem;
            padding-left: 0.3rem;
            position: relative;
            color: #888888;

            span {
              color: #888888;
            }

            &:before {
              content: '';
              position: absolute;
              left: 0;
              width: 0.1621rem;
              height: 0.1621rem;
              top: 0;
              bottom: 0;
              margin: auto 0;
              border-radius: 1rem;
            }

            &:nth-child(1):before {
              background-color: #EC933D;
            }

            &:nth-child(2):before {
              background-color: #50C06A;
            }

            &:nth-child(3):before {
              background-color: #5A85EB;
            }
          }
        }

        .swatch-btn {
          margin-top: 0.2rem;
        }
      }
    }
  }

  .portBox {
    .port-item {
      padding: 0.25rem 0.36rem;
      margin-bottom: 0.29rem;
      background: #ffffff;
      border-radius: 0.19rem;

      .port-left {
        .port-title {
          padding-bottom: 0.1667rem;
          margin-bottom: 0.1667rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 0.4rem;
          color: #000000;
          border-bottom: 1px solid #e5e5e5;

          .port-status {
            width: 0.8rem;
            height: 0.48rem;
            line-height: 0.48rem;
            text-align: center;
            background: #eaeffd;
            border-radius: 0.05rem;
            font-size: 0.28rem;
            color: #2255d9;
          }

          .port-status-use {
            color: #eba40a !important;
            background: #faf0db !important;
          }

          .port-status-error {
            color: #e81515 !important;
            background: #ffe0d7 !important;
          }
        }

        .port-text {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .value {
            color: #444444;
          }

          font-size: 0.32rem;
          color: #666666;
          line-height: 0.6rem;
        }
      }

      .port-right {
        margin-top: 0.36rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .port-btn {
          width: 2.62rem;
          height: 0.74rem;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.32rem;
          color: #9d6b58;
          background: #f6ded5;
          border-radius: 0.09rem;

          .icon-box {
            font-size: 0.4rem;
            margin-right: 0.19rem;
          }
        }

        .port-btn-open {
          color: #fff !important;
          background: #738FD9 !important;
        }

        .port-btn-close {
          color: #666 !important;
          background: #EBEBEB !important;
        }
      }
    }
  }
}
</style>
